import React, {useState} from 'react';
import {Modal, Button, InputGroup, Form, FormControl} from 'react-bootstrap';
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";

import {Pagination} from "../../../../_metronic/_partials/controls";
import {getHandlerTableChange, NoRecordsFoundMessage} from "../../../../_metronic/_helpers";
import {columns} from "./ui.helper";
import {convertFilter} from "../../../../utils/commonUtils";
import {getProductList} from "../../../../redux/modules/products/crud";

export function SearchProductDialog(props) {
  const {open, onHide, onSelect} = props;
  const [listLoading, setLoading] = useState(false);
  const [goodsNm, setGoodsNm] = useState('');
  const [goodsList, setGoodsList] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [query, setQuery] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const handleSearchProducts = async (e) => {
    e.preventDefault();

    const filter = convertFilter({filter: {goodsNm}, ...query});
    try {
      setLoading(true);
      const {pageInfo: {totalCnt}, goodsList} = await getProductList(filter);
      console.log(totalCnt, goodsList);
      setLoading(false);
      setGoodsList(goodsList);
      setTotalSize(totalCnt);
    } catch(err) {
      console.log(err);
    }
  };

  const handleRowClick = (e, row) => {
    onSelect(row);
    onHide();
  };

  const pagination = {
    custom: true,
    totalSize: totalSize,
    page: query.pageNumber,
    sizePerPage: query.pageSize,
  };

  return (
    <Modal show={open} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>상품 검색</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-5" style={{maxWidth: 500}}>
          <Form onSubmit={handleSearchProducts}>
            <InputGroup>
              <FormControl
                placeholder="상품명을 입력하세요."
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                maxLength={50}
                onChange={e => setGoodsNm(e.target.value)}
              />
              <InputGroup.Append>
                <Button type="submit" variant="success">상품검색</Button>
              </InputGroup.Append>
            </InputGroup>
          </Form>
        </div>

        <PaginationProvider pagination={paginationFactory(pagination)}>
          {({paginationProps, paginationTableProps}) => (
            <Pagination isLoading={listLoading} paginationProps={paginationProps} hidePageList={true}>
              <BootstrapTable
                remote
                bootstrap4
                keyField="no"
                hover
                bordered={true}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                data={goodsList === null ? [] : goodsList}
                //defaultSorted={uiHelpers.defaultSorted}
                noDataIndication={<NoRecordsFoundMessage entities={goodsList}/>}
                rowEvents={{ onClick: handleRowClick }}
                onTableChange={getHandlerTableChange(setQuery)}
                {...paginationTableProps}
              />
            </Pagination>
          )}
        </PaginationProvider>
      </Modal.Body>
    </Modal>
  );

}
